export const APPROVAL_STATUS_PENDING = {label: 'Pending', _id: '507f1f77bcf86cd799439022'};
export const APPROVAL_STATUS_APPROVED = {label: 'Approved', _id: '507f1f77bcf86cd799439023'};
export const APPROVAL_STATUS_REJECTED = {label: 'Rejected', _id: '507f1f77bcf86cd799439024'};
